import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Tab, Label, Image } from 'semantic-ui-react'

import Toastr from 'modern-toastr';
import CanvasJSReact from 'utils/canvasjs.react';

import * as moment from 'moment';
import * as service from 'services/system';

Toastr.setPosition('toast-top-center');

const CanvasJSChart = CanvasJSReact.CanvasJSChart;
const mapStateToProps = state => ({
    user: state.auth.user
});

class UserStatisticUserConnect extends Component {    

    constructor(props) {
        super(props);

        this.state = {
            startDate: props.startDate,
            endDate: props.endDate,
            joinUsers: [],
            paidUsers: []
        }
    }

    componentDidMount() {
        //console.log(this.state);
        const { startDate, endDate } = this.state;
        if(startDate !== undefined && startDate !== null && startDate !== '' &&
            endDate !== undefined && endDate !== null && endDate !== ''
        ) {
            this.fetchSelectUserConnectStatistic({
                startDate: startDate,
                endDate: endDate
            })
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if(nextProps.startDate !== prevState.startDate ||
            nextProps.endDate !== prevState.endDate
            ) {            
            return { 
                startDate: nextProps.startDate,
                endDate: nextProps.endDate
            };
        }
        return null;
    }

    componentDidUpdate(prevProps, prevState) {    
        const { startDate, endDate } = this.state;     
        if(startDate !== prevState.startDate || endDate !== prevState.endDate
            ) {
            this.fetchSelectUserConnectStatistic({
                startDate: startDate,
                endDate: endDate
            })            
        }
    }

    fetchSelectUserConnectStatistic = async (params) => {

        const user = this.props.user;
        const statisticInfo = await service.selectUserConnectStatistic(params); 

        //console.log(statisticInfo);

        if(user !== undefined && user !== null && user.grade === 0) {
            if(statisticInfo !== null) {            
                if(statisticInfo.status === 200) {
                    if(statisticInfo.data) {
                        this.showUserStatistic(statisticInfo.data.datas);    
                    } else {
                        
                    }             
                } else {
                    Toastr.error(statisticInfo.data.message);
                }
            } else {
                Toastr.error('사용자 접속 정보를 불러오는 중에 오류가 발생하였습니다. 다시 시도해 주세요.');
            }  
        }
    }

    showUserStatistic(data) {
        //console.log(data);
        if(data.length > 0) {
            let joinUsers = [];
            let paidUsers = [];
            data.map((item, index) => {
                joinUsers.push({label: item.INS_DATE, y: item.CNT});
            });

            this.setState({
                joinUsers: joinUsers
            });
        }
    }
    
    render() {        

        const { joinUsers, paidUsers } = this.state;
        const options = {
			theme: "light2",
			animationEnabled: true,
			title: {
				text: "사용자 접속수"
			},
			subtitles: [{
				text: ""
            }],            
			axisY: {
				includeZero: false,
				prefix: ""
			},
			toolTip: {
				shared: true
			},
			data: [
			{
				type: "area",
				name: "접속자",
				showInLegend: true,
				yValueFormatString: "#,##0.##",
				dataPoints: joinUsers
			}			
			]
		}

        return (           
            <Fragment>
                <div className='row mt-4'>
                    <div className='col-12 mb-4'>
                        <CanvasJSChart options = {options} />
                    </div>
                </div>
            </Fragment>      
        );
    }
}

export default connect(mapStateToProps, null)(withRouter(UserStatisticUserConnect));